export default "__VITE_ASSET__DiFhVJ0p__"